import request from '../utils/request'
import { articleListDataCook, seminarListDataCook, hotNewsListDataCook, partnerChildListDataCook, getUserSess, getGlobalUserId, 
    wonderfulWordsDataCook, wonderfulPicDataCook, guestListDataCook, extHallDataCook, exthallDetailDataCook, getTc, getShareKey,
    exthallDetailDataCookStepTwo, fileFolderDataCook, userDataCook, specialTopicFilesCook, extHallTriDataCook, guideDataCook, 
    agendaAddressDataCook, liveCateDataCook } from '../utils/tool'
import Config from '@/config'
import wx from 'weixin-js-sdk';
import store from "@/store";

export default {

     /*获取注册人信息*/
    getContatsInfo(params) {
        return new Promise(((resolve,reject) => {
                //接口
                request.postJson('/partners/contats/get', params,{baseURL: request.url}).then((res) => {
                    resolve(res);
                }).catch((err)=>{
                    reject(err);
                });
        }))
    },
     /* 获取分会场会议列表*/
     getsubSeminarList(params) {
         return new Promise((resolve => {
             request.getJson(Config.tenantId + '/seminar/' + params.seminarId + '/subSeminar/list' + '.json', {baseURL: request.JsonUrl}).then((res) => {
                 resolve(res)
             }).catch(() => {
                 //接口
                 request.postJson('/api/seminar/subseminar/information/query', params).then((res) => {
                     resolve(res);
                 });
             })
         }))
     },
    /* 获取分会场详情*/
    getsubSeminarInfo(params) {
        return new Promise((resolve => {
            request.getJson(Config.tenantId + '/seminar/' + Config.seminarId + '/subSeminar/list' +params.subSeminarId+ '.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/api/seminar/subseminar/get', params).then((res) => {
                    resolve(res);
                });
            })

        }))
    },
    /* 获取会议场地列表*/
    getPlaceList(params) {
        return new Promise((resolve => {
            request.getJson(Config.tenantId + '/custom/partner/api_place_query.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/api/place/query', params,{baseURL: request.url}).then((res) => {
                    resolve(res);
                });
            })

        }))
    },
    /**
     * 获取首页主会场和分论坛视频
     */
    getVideoSeminarList(){
       return new Promise((resolve=>{
           request.getJson(Config.tenantId + '/custom/partner/subSeminar/videoList.json', {baseURL: request.JsonUrl}).then((res) => {
               resolve(res)
           })
       }))
    },
    /**
     * 获取会议详情
     */
    getSeminarInfo(params) {
        return new Promise((resolve => {
            /* params._cache_refresh=1;
             params._cache_timeout=1800;
             params._cache_with_cached=1;
             //接口
             request.postJson('/api/seminar/get', params).then((res) => {
                 resolve(res);
             });*/
            request.getJson('api_seminar_get_' + params.seminarId + '.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/api/seminar/get', params).then((res) => {
                    resolve(res);
                });
            })
        }));
    },
    /**
     * 获取会议详情带自定义字段
     * @param params
     * @returns {boolean}
     */
    getSeminarDetail(params) {
        return new Promise((resolve => {
            /* params._cache_refresh=1;
             params._cache_timeout=1800;
             params._cache_with_cached=1;
             //接口
             request.postJson('/api/seminar/get', params).then((res) => {
                 resolve(res);
             });*/
            request.getJson('seminar_topicTemplate_seminar_get_' + params.seminarId + '.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
            //接口
            request.postJson('/seminar/topicTemplate/seminar/get', params).then((res) => {
                resolve(res);
             });
           })
        }));
    },
    /**
     * 资料中心获取文件列表
     */
    getFileList(params) {
        return new Promise((resolve => {
            request.getJson(Config.tenantId+'/custom/partner/filelist_' + params.folderId + '.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/file/getList', params).then((res) => {
                    resolve(res);
                });
            })
        }));
    },

    /**
     * 资料中心获取文件列表
     */
    getFileInfo(params) {
        return new Promise((resolve => {
            request.getJson(Config.tenantId + '/seminar/' + Config.seminarId + '/file/list/' + params.fileIds + '.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/file/getList', params).then((res) => {
                    resolve(res);
                });
            })
        }));
    },

    /**
     * 获取文章栏目列表（产品静态化）
     */
    getArticleCategoryList(params) {
        return new Promise((resolve => {
            request.getJson(Config.tenantId+'/custom/partner/article_category_' + params.articleCategoryId + '.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/api/article/category/sub/query', params).then((res) => {
                    resolve(res);
                });
            })
        }));
    },
    /**
     * 获取文章列表
     */
    getArticleList(params) {
        return new Promise((resolve => {
            request.getJson('article_getListByProject_' + params.articleCategoryId + '_-1.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/article/getListByProject', params).then((res) => {
                    resolve(res);
                });
            })
        }));
    },
    /**
     * 获取文章详情
     */
    getArticleDetail(params) {
        return new Promise((resolve => {
            request.getJson('article_getDetail_' + params.articleId + '.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/article/getDetail', params).then((res) => {
                    resolve(res);
                });
            })
        }));
    },
    /**
     *首页文章详情（带自定义字段）
     */
    getArticleDetailWithDefineField(params) {
        return new Promise((resolve => {
            request.getJson(Config.tenantId+'/article/' + params.articleId + '.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/api/article/get', params).then((res) => {
                    resolve(res);
                });
            })
        }));
    },
    /**
     * 记录文章浏览量
     */
    ArticleBrowse(params) {
        return request.postJson('/article/browse', params)
    },
    /**
     * 描点
     */
    record(params) {
        return request.postJson('/partner/interaction/view/record', params, {baseURL: request.url})
    },
    /**
     * 获取会议
     * @param params
     */
    getSeminarList(params) {
        return new Promise((resolve) => {
            request.getJson('api_seminar_query_主题演讲2019-分论坛2019-开放演讲2019.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/api/seminar/query', params).then((res) => {
                    resolve(res);
                });
            })
        });
    },
    /*首页获取主题演讲静态json*/
    getSeminarListZtyj(params) {
        return new Promise((resolve) => {
            request.getJson('api_seminar_query_主题演讲2019.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/api/seminar/query', params).then((res) => {
                    resolve(res);
                });
            })
        });
    },
    /**
     * 获取会议内容类别
     * @param params
     */
    getSeminarCategory(params) {
        return new Promise((resolve) => {
            request.getJson(Config.tenantId+'/dic/list/' + params.dicId + '.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/dic/params/getTree', params).then((res) => {
                    resolve(res);
                });
            })
        });
    },
    /**
     * 获取嘉宾列表
     * @param params
     */
    getSeminarGuestsList(params, type) {
        if (type == 1) {//表示主题演讲2019
            return new Promise((resolve => {
                request.getJson(Config.tenantId+'/custom/partner/seminar_GuestsList_主题演讲_2020.json', {baseURL: request.JsonUrl}).then((res) => {
                    resolve(res)
                }).catch(() => {
                    //接口
                    request.postJson('/partner/guests/get', params, {baseURL: request.url}).then((res) => {
                        resolve(res);
                    });
                })
            }))
        } else {//分论坛2019
            return new Promise((resolve => {
                request.getJson(Config.tenantId+'/custom/partner/seminar_GuestsList_峰会/分论坛_2020.json', {baseURL: request.JsonUrl}).then((res) => {
                    resolve(res)
                }).catch(() => {
                    //接口
                    return request.postJson('/partner/guests/get', params, {baseURL: request.url}).then((res) => {
                        resolve(res);
                    });
                })
            }))
        }
    },
    /**
     * 获取展区列表
     * @returns {Q.Promise<any> | AxiosPromise<any>}
     */
    getExhibitionList(obj = {}) {
        let info = {
            instanceId: "",
            articleCategoryId: Config.exhibitionId,
            tenantId: Config.tenantId,
            moduleId: "",
            isEnabled: 1,
        }
        let params = Object.assign({}, info, obj);
        return new Promise((resolve => {
            /*params._cache_refresh=1;
            params._cache_timeout=1800;
            params._cache_with_cached=1;
            //接口
            request.post('articleCategory/getList', params).then((res) => {
                resolve(res);
            });*/
            request.getJson('articleCategory_getList_' + Config.exhibitionId + '.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.post('articleCategory/getList', params).then((res) => {
                    resolve(res);
                });
            })
        }))
    },
    /**
     * 获取文件列表
     * @param obj
     */
    getFiles(obj = {}) {
        let info = {
            folderId: '',
            start: 0,
            num: 50,
            sortType: 6,
            name: '',
            fileIds: [],
            type: '',
            fileTypes: '',
            instanceId: '',
            moduleType: '',
            isShowSys: '',
            tenantId: Config.tenantId
        }
        let params = Object.assign({}, info, obj);
        let fileIds = params.fileIds;
        return new Promise((resolve => {
            request.getJson('file_getList_0_' + fileIds + '.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/file/getList', params).then((res) => {
                    resolve(res);
                });
            })
        }));
    },
    /**
     * 邮箱下载文件
     * @param obj
     */
    getDowningFile(obj = {}) {
        let info = {
            email: '',
            fileList: [],
            openId: "",
            articleId: "",
            forEmailTemp: true,
            referenceUrl: "",
            moduleType: [],
            instanceId: 11294,
            extra: ''
        }
        let params = Object.assign({}, info, obj)
        return request.postJson('/file/downloadWithEmail', params, {
            baseURL: 'https://hwproject-api.smarket.net.cn'
        })
    },
    /**
     * 获取报名用户信息
     * @param params
     */
    getSeminarContacts(params) {
        return request.postJson('/api/seminar/contacts/get', params)
    },
    /**
     * 发送邮箱
     * @param params
     */
    downloadWithEmail(params) {
        // params.sess = getUserSess();
        // params.seminarId = Config.seminarId;
        // params.instanceId = Config.instanceId;
        // return request.postJson('/file/downloadWithEmail', params,)
        
        let param = {
            email: params.email,
            fileIds: params.fileList,
            globalUserId: getGlobalUserId(),
            seminarId: Config.seminarId,
            sess: getUserSess(),
            type: 'templatePoint',
            tmpName: "partner2021",
        };

        return request.postJson('/partner/file/downloads', param, { baseURL: Config.api.gateway.project })
        // return request.postJson('/file/downloadWithEmail', params,)
    },
    /**
     * 记录互动
     * @param params
     */
    interactionRrecord(params) {
        return request.postJson('/interaction/record', params)
    },

    //获取参会指南列表
    getGuideList(params) {
        return new Promise((resolve => {
            /* params._cache_refresh=1;
             params._cache_timeout=1800;
             params._cache_with_cached=1;
             //接口
             request.post('article/getList', params).then((res) => {
                 resolve(res);
             });*/
            request.getJson(Config.tenantId+'/custom/partner/article_list_' + params.articleCategoryId + '.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.post('article/getList', params).then((res) => {
                    resolve(res);
                });
            })
        }))
    },
    /**
     * 获取栏目下文章，返回中带有自定义字段（接口静态化产品化接口）
     */
    getArticleQueryList(params) {
        return new Promise((resolve => {
            request.getJson(Config.tenantId+'/article/list/' + params.articleCategoryId + '.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.post('api/article/query', params).then((res) => {
                    resolve(res);
                });
            })
        }))
    },
    /***
     * 初始化微信分享
     */
    wxshare() {
        /* return request.postJson('/article/share', {baseURL: request.JsonUrl},{
           /!*  url: window.location.href.split('#')[0]*!/
             url: 'https://e-campaign.huawei.com/campaign/uat/partner2019-minisite/#/home'
         });*/
        return request.postJson('/article/share', {
            url: window.location.href.split('#')[0]
        }, {baseURL: request.wxUrl})
    },
    onWxShare(title, summary,url) {
        let tc = '',wxUrl='';

        //如果存在tc可能通过微信分享获得
        if (location.hash.match(/tc\=([\w\d]+)/)) {
            tc = location.hash.match(/tc\=([\w\d]+)/)[1];
        }
        //如果存在localStorage
        if (localStorage.getItem('tc')) {
            tc = localStorage.getItem('tc');
        }
        if(window.location.href.indexOf('/home?')>0){
            if (!window.location.href.match(/tc\=([\w\d]+)/) && tc!='') {//如果地址栏中不带tc且localstorage中带有tc
                wxUrl = window.location.href + '&tc=' + tc;
            }else{
                wxUrl = window.location.href;
            }
        }else{
            if (!window.location.href.match(/tc\=([\w\d]+)/) && tc!='') {//如果地址栏中不带tc且localstorage中带有tc
                wxUrl = window.location.href + '?tc=' + tc;
            }else{
                wxUrl = window.location.href;
            }
        }

        return request.postJson('/article/share', {
            url: window.location.href.split('#')[0]
        }, {baseURL: request.wxUrl}).then((data) => {
            wx.config({
                debug: false,
                appId: data.content.appId, // 和获取Ticke的必须一样------必填，公众号的唯一标识
                timestamp: data.content.timestamp, // 必填，生成签名的时间戳
                nonceStr: data.content.nonceStr, // 必填，生成签名的随机串
                signature: data.content.signature,// 必填，签名，见附录1
                //需要分享的列表项:发送给朋友，分享到朋友圈，分享到QQ，分享到QQ空间
                jsApiList: [
                    'onMenuShareAppMessage', 'onMenuShareTimeline',
                    'onMenuShareQQ', 'onMenuShareQZone'
                ]
            });
            wx.ready(() => {
                //分享到朋友圈
                wx.onMenuShareTimeline({
                    title: Config.shareTitle + title, // 分享标题
                    desc: summary||Config.shareDesc, // 分享描述
                    link: url ? url : wxUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: Config.shareImgUrl, // 分享图标
                    success: function () {

                    }
                });
                //分享给朋友
                wx.onMenuShareAppMessage({
                    title: Config.shareTitle + title, // 分享标题
                    desc: summary||Config.shareDesc, // 分享描述
                    link: url ? url :wxUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: Config.shareImgUrl, // 分享图标
                    type: '', // 分享类型,music、video或link，不填默认为link
                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                    success: function () {
                    }
                });
                //分享到QQ
                wx.onMenuShareQQ({
                    title: Config.shareTitle + title, // 分享标题
                    desc: summary||Config.shareDesc, // 分享描述
                    link: url ? url :wxUrl, // 分享链接
                    imgUrl: Config.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                    }
                });

                //分享到QQ空间
                wx.onMenuShareQZone({
                    title: Config.shareTitle + title, // 分享标题
                    desc: summary||Config.shareDesc, // 分享描述
                    link: url ? url : wxUrl, // 分享链接
                    imgUrl: Config.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                    }
                });
            });
        });
    },
    /**
     * 获取服务器时间
     */
    getServeTime(){
        return request.postJson('/api/project/server/GetTime', {}, {baseURL: request.url})
    },
    /**
     * 获取峰会分论坛下的资料
     * */
    getSubFileList(params) {
        return new Promise((resolve => {
            request.getJson(Config.tenantId + '/custom/partner/partner_flt2020_files' + '.json', {baseURL: request.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口https://hwuat-static.smarket.net.cn/519/custom/partner/partner_flt_files.json
                request.postJson('/partner/guests/query', params, {baseURL: request.url}).then((res) => {
                    resolve(res);
                });
            });
        }));
    },
    /**
     * 批量下载资料
     * */
    downloadFiles(params) {
        return new Promise(((resolve,reject) => {
            request.postJson('/partner/file/downloads', params, {baseURL: request.url}).then((res)=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            });
        }))
    },
    /**
     * 获取文章详情
     */
    getArticleDetailMoment(param) {
        let params={
            tenantId:  Config.tenantId,
            isWithStat: 0,//是否需要点赞、分享、浏览统计（1：是；0：否）
            isScroll: 0,//是否需要查询上一篇和下一篇文章id（1：是；0：否）
            isWithTag: 0,//是否需要标签（1：是；0：否）
            ...param
        };
        return new Promise((resolve => {
            request.getJson(Config.tenantId+'/seminar/'+Config.seminarId+'/article/' + params.articleId + '.json', {baseURL: Config.api.gateway.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/article/getDetail', params).then((res) => {
                    resolve(res);
                });
            })
        }));
    },
    /**
     * 根据栏目id获取栏目下的文章列表
     */
    getCategoryArticleListInfo(param) {
        let params={
            "isRecommend": -1,
            "instanceId": Config.instanceId,
            "title": "",
            "tenantId": Config.tenantId,
            "isStick": -1,
            "isTop": "-1",
            "isWithStat": "1",
            "hasChildrenCategory": "0",
            "tags": [],
            "start": 0,
            "num": 50,
            "sort": 6,
            ...param
        };
        return new Promise((resolve => {
            request.getJson(Config.tenantId+'/seminar/'+Config.seminarId+'/article/list/' + params.articleCategoryId + '.json', {baseURL: Config.api.gateway.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('api/article/query', params).then((res) => {
                    resolve(res);
                });
            })
        }))
    },
    getHeavyInfosList(param) {
        let params={
            "isRecommend": -1,
            "instanceId":'',
            "title": "",
            "tenantId": Config.tenantId,
            "isStick": -1,
            "isTop": "-1",
            "isWithStat": "1",
            "hasChildrenCategory": "0",
            "tags": [],
            "start": 0,
            "num": 50,
            "sort": 6,
            ...param
        };
        return new Promise((resolve => {
            request.getJson(Config.tenantId+'/article/list/' + params.articleCategoryId + '.json', {baseURL: Config.api.gateway.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('api/article/query', params).then((res) => {
                    resolve(res);
                });
            })
        }))
    },

    // 2021 start
    // 新闻资讯
    getNewsList(){
        let params={
            "isRecommend": -1,
            "instanceId": Config.instanceId,
            "title": "",
            "tenantId": Config.tenantId,
            "isStick": -1,
            "isTop": "-1",
            "isWithStat": "1",
            "hasChildrenCategory": "0",
            "tags": [],
            "start": 0,
            "num": 50,
            "sort": 6,
            seminarId: Config.seminarId,
            articleCategoryId: Config.reviewArticleCategory.newsArticleCategoryId,
        };
        return new Promise(((resolve, reject) => {
            if(store.state.cache.newsList.length){
                resolve(store.state.cache.newsList);
            }else{
                request.getJson(Config.tenantId+'/seminar/'+Config.seminarId+'/article/list/' + Config.reviewArticleCategory.newsArticleCategoryId + '.json', {baseURL: Config.api.gateway.JsonUrl}).then((res) => {
                    store.commit('setNewsListCache', hotNewsListDataCook(res));
                    resolve(store.state.cache.newsList)
                }).catch(() => {
                    //接口
                    request.postJson('api/article/query', params).then((res) => {
                        resolve(res);
                    })
                    .catch(err=>{
                        store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                        reject(err);
                    });
                })
            }
        }))
    },
    // 精彩视频
    getWonderfulVideoList(){
        let params={
            "isRecommend": -1,
            "instanceId": Config.instanceId,
            "title": "",
            "tenantId": Config.tenantId,
            "isStick": -1,
            "isTop": "-1",
            "isWithStat": "1",
            "hasChildrenCategory": "0",
            "tags": [],
            "start": 0,
            "num": 50,
            "sort": 6,
            seminarId: Config.seminarId,
            articleCategoryId: Config.reviewArticleCategory.wonderfulVideo,
        };
        return new Promise(((resolve, reject) => {
            if(store.state.cache.wonderfulVideoList.length){
                resolve(store.state.cache.wonderfulVideoList);
            }else{
                request.getJson(Config.tenantId+'/seminar/'+Config.seminarId+'/article/list/' + Config.reviewArticleCategory.wonderfulVideo + '.json', {baseURL: Config.api.gateway.JsonUrl}).then((res) => {
                    store.commit('setWonderfulVideoListCache', articleListDataCook(res));
                    resolve(articleListDataCook(res))
                }).catch(() => {
                    //接口
                    request.postJson('api/article/query', params).then((res) => {
                        resolve(res);
                    })
                    .catch(err=>{
                        store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                        reject(err);
                    });
                })
            }
        }))
    },
    // 生态伙伴
    getPartnerList(){
        let params={
            "isRecommend": -1,
            "instanceId": Config.instanceId,
            "title": "",
            "tenantId": Config.tenantId,
            "isStick": -1,
            "isTop": "-1",
            "isWithStat": "1",
            "hasChildrenCategory": "0",
            "tags": [],
            "start": 0,
            "num": 50,
            "sort": 6,
            seminarId: Config.seminarId,
            articleCategoryId: Config.reviewArticleCategory.partnerArticleCategoryId,
        };
        return new Promise(((resolve, reject) => {
            if(store.state.cache.partnerList.length){
                resolve(store.state.cache.partnerList);
            }else{
                request.getJson(Config.tenantId+'/seminar/'+Config.seminarId+'/article/category/' + Config.reviewArticleCategory.partnerArticleCategoryId + '.json', {baseURL: Config.api.gateway.JsonUrl}).then((res) => {
                    if(res.result == 0){
                        let partnerTemp = [];
                        res.content.items.map(item=>{
                            partnerTemp.push({
                                name: item.title,
                                categoryId: item.articleCategoryId,
                                list: []
                            });
                        });
                        store.commit('setPartnerListCache', partnerTemp);

                        Promise.all([this.getPartnerChildList(partnerTemp[0].categoryId),
                            this.getPartnerChildList(partnerTemp[1].categoryId),
                            this.getPartnerChildList(partnerTemp[2].categoryId),
                            this.getPartnerChildList(partnerTemp[3].categoryId),
                            this.getPartnerChildList(partnerTemp[4].categoryId),
                            this.getPartnerChildList(partnerTemp[5].categoryId)])
                        .then(function(values) {
                                //执行完
                                resolve(store.state.cache.partnerList);
                        })
                        .catch(err=>{
                            reject(err);
                        });
                    }else{
                        reject(res);
                    }
                }).catch(() => {
                    //接口
                    request.postJson('/api/article/category/sub/query', params).then((res) => {
                        resolve(res);
                    }).catch(err=>{
                        store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                        reject(err);
                    });
                })
            }
        }))
    },
    // 生态伙伴子分类列表数据
    getPartnerChildList(articleCategoryId){
        let params={
            "isRecommend": -1,
            "instanceId": Config.instanceId,
            "title": "",
            "tenantId": Config.tenantId,
            "isStick": -1,
            "isTop": "-1",
            "isWithStat": "1",
            "hasChildrenCategory": "0",
            "tags": [],
            "start": 0,
            "num": 50,
            "sort": 6,
            seminarId: Config.seminarId,
            articleCategoryId: articleCategoryId,
        };
        return new Promise(((resolve, reject) => {
            request.getJson(Config.tenantId+'/seminar/'+Config.seminarId+'/article/list/' + articleCategoryId + '.json', {baseURL: Config.api.gateway.JsonUrl}).then((res) => {
                let retData = partnerChildListDataCook(res);
                store.commit('setPartnerChildListCache', {id: articleCategoryId, list:retData});
                resolve(retData)
            }).catch(() => {
                //接口
                request.postJson('/api/article/category/sub/query', params).then((res) => {
                    resolve(res);
                }).catch(err=>{
                    store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            })
        }))
    },
    // 获取议程列表
    async getNewSubSeminarList() {
        if(store.state.cache.agendaAddress.length == 0){
            let addressRes = await this.getAgendaAddress();
        }

        return new Promise( (resolve => {
            if(store.state.cache.seminarList){
                resolve(seminarListDataCook(store.state.cache.seminarList));
            }else{
                request.getJson(Config.tenantId + '/seminar/' + Config.seminarId + '/subSeminar/list.json', {baseURL: request.JsonUrl}).then((res) => {
                    store.commit('setSeminarListCache', res);
                    resolve(seminarListDataCook(res))
                }).catch(() => {
                    //接口
                    let params1 = {
                        tenantId: Config.tenantId,
                        seminarId: Config.seminarId,
                        start: 0,
                        num: 50,
                        expandInfo: ['agenda']
                    };
                    let params2 = {
                        tenantId: Config.tenantId,
                        seminarId: Config.seminarId,
                        start: 50,
                        num: 50,
                        expandInfo: ['agenda']
                    };
                    let params3 = {
                        tenantId: Config.tenantId,
                        seminarId: Config.seminarId,
                        start: 100,
                        num: 50,
                        expandInfo: ['agenda']
                    };
                    Promise.all([request.postJson('/api/seminar/subseminar/information/query', params1),
                        request.postJson('/api/seminar/subseminar/information/query', params2),
                        request.postJson('/api/seminar/subseminar/information/query', params3)])
                    .then(function(values) {
                            //执行完
                            let ret = {
                                result: 0,
                                content:{
                                    items: []
                                }
                            };
                            ret.content.items = ret.content.items.concat(values[0].content.items);
                            ret.content.items = ret.content.items.concat(values[1].content.items);
                            ret.content.items = ret.content.items.concat(values[2].content.items);

                            store.commit('setSeminarListCache', ret);
                            resolve(seminarListDataCook(ret))
                    })
                    .catch(err=>{
                        store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                        reject(err);
                    });
                })
            }
        }))
    },
    // 获取直播分类字典
    getLiveCate(){
        return new Promise((resolve, reject) => {
            if(store.state.cache.liveCate){
                resolve(store.state.cache.liveCate);
            }else{
                request.getJson(Config.tenantId+'/dic/list/' + Config.liveCateDicId + '.json', {baseURL: request.JsonUrl}).then((res) => {
                    liveCateDataCook(res);
                    resolve(store.state.cache.liveCate)
                }).catch(() => {
                    //接口
                    let params = {
                        tenantId: Config.tenantId,
                        dicId: Config.liveCateDicId,
                    };
                    request.postJson('/dic/params/getTree', params).then((res) => {
                        liveCateDataCook(res);
                        resolve(store.state.cache.liveCate)
                    })
                    .catch(err=>{
                        store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                        reject(err);
                    });
                })
            }
        });
    },
    // 获取议程筛选字典
    getSubSeminarFilterData(){
        return new Promise((resolve) => {
            if(store.state.cache.agendaFilterData){
                resolve(store.state.cache.agendaFilterData);
            }else{
                request.getJson(Config.tenantId+'/dic/list/' + Config.agendaDicId + '.json', {baseURL: request.JsonUrl}).then((res) => {
                    if(res.result == 0){
                        store.commit('setAgendaFilterDataCache', res.content[Config.agendaDicId]);
                    }
                    resolve(store.state.cache.agendaFilterData)
                }).catch(() => {
                    //接口
                    request.postJson('/dic/params/getTree', params).then((res) => {
                        resolve(res);
                    })
                    .catch(err=>{
                        store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                        reject(err);
                    });
                })
            }
        });
    },
    // 获取专题演讲楼层字典
    getSpecialAddressDict(){
        return new Promise((resolve) => {
            if(store.state.cache.specialAddressDict){
                resolve(store.state.cache.specialAddressDict);
            }else{
                request.getJson(Config.tenantId+'/dic/list/' + Config.floorDicId + '.json', {baseURL: request.JsonUrl}).then((res) => {
                    if(res.result == 0){
                        store.commit('setSpecialAddressDictCache', res.content[Config.floorDicId]);
                    }
                    resolve(store.state.cache.specialAddressDict)
                }).catch(() => {
                    //接口
                    request.postJson('/dic/params/getTree', params).then((res) => {
                        resolve(res);
                    })
                    .catch(err=>{
                        store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                        reject(err);
                    });
                })
            }
        });
    },
    // 获取大会介绍
    getNewSubSeminarInfo() {
        return new Promise((resolve => {
            if(store.state.cache.seminarInfo){
                resolve(store.state.cache.seminarInfo.desc);
            }else{
                request.getJson(Config.tenantId + '/seminar/' + Config.seminarId + '/info.json', {baseURL: request.JsonUrl}).then((res) => {
                    if(res.result == 0){
                        store.commit('setSeminarInfoCache', res.content);
                        resolve(store.state.cache.seminarInfo.desc)
                    }
                    resolve(store.state.cache.seminarInfo)
                }).catch(() => {
                    //接口
                    request.postJson('/api/seminar/subseminar/get', params).then((res) => {
                        resolve(res);
                    })
                    .catch(err=>{
                        store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                        reject(err);
                    });
                })
            }
        }))
    },
    // 精彩图集
    getWonderfulPic(){
        let params={
            "isRecommend": -1,
            "instanceId": Config.instanceId,
            "title": "",
            "tenantId": Config.tenantId,
            "isStick": -1,
            "isTop": "-1",
            "isWithStat": "1",
            "hasChildrenCategory": "0",
            "tags": [],
            "start": 0,
            "num": 50,
            "sort": 6,
            seminarId: Config.seminarId,
            articleCategoryId: Config.reviewArticleCategory.wonderfulPic,
        };
        return new Promise(((resolve, reject) => {
            if(store.state.cache.wonderfulPic){
                resolve(store.state.cache.wonderfulPic);
            }else{
                request.getJson(Config.tenantId+'/seminar/'+Config.seminarId+'/article/list/' + Config.reviewArticleCategory.wonderfulPic + '.json', {baseURL: Config.api.gateway.JsonUrl}).then((res) => {
                    let data = wonderfulPicDataCook(res);
                    store.commit('setWonderfulPicCache', data);
                    resolve(data)
                }).catch(() => {
                    //接口
                    request.postJson('api/article/query', params).then((res) => {
                        resolve(res);
                    })
                    .catch(err=>{
                        store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                        reject(err);
                    });
                })
            }
        }))
    },
    // 大咖观点
    getWonderfulWords(){
        let params={
            "isRecommend": -1,
            "instanceId": Config.instanceId,
            "title": "",
            "tenantId": Config.tenantId,
            "isStick": -1,
            "isTop": "-1",
            "isWithStat": "1",
            "hasChildrenCategory": "0",
            "tags": [],
            "start": 0,
            "num": 50,
            "sort": 6,
            seminarId: Config.seminarId,
            articleCategoryId: Config.reviewArticleCategory.wonderfulWords,
        };
        return new Promise(((resolve, reject) => {
            if(store.state.cache.wonderfulWords){
                resolve(store.state.cache.wonderfulWords);
            }else{
                request.getJson(Config.tenantId+'/seminar/'+Config.seminarId+'/article/list/' + Config.reviewArticleCategory.wonderfulWords + '.json', {baseURL: Config.api.gateway.JsonUrl}).then((res) => {
                    let data = wonderfulWordsDataCook(res);
                    store.commit('setWonderfulWordsCache', data);
                    resolve(data)
                }).catch(() => {
                    //接口
                    request.postJson('api/article/query', params).then((res) => {
                        resolve(res);
                    })
                    .catch(err=>{
                        store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                        reject(err);
                    });
                })
            }
        }))
    },
    // 获取嘉宾列表
    getGuestList() {
        let params={
            returnType: 'api',
            seminarId: Config.seminarId,
            categorys: ['主题演讲'],
            obsPathName: 'seminar_GuestsList_主题演讲_2021.json',
            tenantId: Config.tenantId,
        };
        return new Promise((resolve => {
            if(store.state.cache.guestList){
                resolve(store.state.cache.guestList);
            }else{
                request.getJson(Config.tenantId+'/custom/partner/seminar_GuestsList_主题演讲_2021.json', {baseURL: request.JsonUrl}).then((res) => {
                    let data = guestListDataCook(res);
                    store.commit('setGuestListCache', data);
                    resolve(data)
                }).catch(() => {
                    //接口
                    request.postJson('/partner/guests/get', params, {baseURL: request.url}).then((res) => {
                        let data = guestListDataCook(res);
                        store.commit('setGuestListCache', data);
                        resolve(data);
                    }).catch(err=>{
                        store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                        reject(err);
                    });
                })
            }
        }))
    },
    // 展厅列表
    getExthallParentList(){
        let params={
            "isRecommend": -1,
            "instanceId": Config.instanceId,
            "title": "",
            "tenantId": Config.tenantId,
            "isStick": -1,
            "isTop": "-1",
            "isWithStat": "1",
            "hasChildrenCategory": "0",
            "tags": [],
            "start": 0,
            "num": 50,
            "sort": 6,
            seminarId: Config.seminarId,
            articleCategoryId: Config.reviewArticleCategory.exhibition,
        };
        return new Promise(((resolve, reject) => {
            // if(store.state.cache.extHallList){
            //     resolve(store.state.cache.extHallList);
            // }else{
                request.getJson(Config.tenantId+'/seminar/'+Config.seminarId+'/article/category/' + Config.reviewArticleCategory.exhibition + '.json', {baseURL: Config.api.gateway.JsonUrl}).then((res) => {
                    if(res.result == 0){
                        let data = extHallDataCook(res);
                        // store.commit('setExtHallListCache', data);
                        resolve(data);
                    }else{
                        reject(res);
                    }
                }).catch(() => {
                    //接口
                    request.postJson('/api/article/category/sub/query', params).then((res) => {
                        resolve(res);
                    }).catch(err=>{
                        store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                        reject(err);
                    });
                })
            // }
        }))
    },
    // 展厅列表
    getExthallList(){
        return new Promise(((resolve, reject) => {
            if(store.state.cache.extHallList){
                resolve(store.state.cache.extHallList);
            }else{
                Promise.all([this.getExthallChildList(Config.reviewArticleCategory.exhibitionShengtai),
                    this.getExthallChildList(Config.reviewArticleCategory.exhibitionChanye),
                    this.getExthallChildList(Config.reviewArticleCategory.exhibitionHangye)])
                .then(function(values) {
                        //执行完
                    let data = extHallTriDataCook(values);
                    store.commit('setExtHallListCache', data);
                    resolve(data);
                    // if(res.result == 0){
                        
                    // }else{
                    //     reject(res);
                    // }
                })
                .catch(err=>{
                    store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            }
        }))
    },
    // 展厅子栏目列表
    getExthallChildList(cateId){
        let params={
            "isRecommend": -1,
            "instanceId": Config.instanceId,
            "title": "",
            "tenantId": Config.tenantId,
            "isStick": -1,
            "isTop": "-1",
            "isWithStat": "1",
            "hasChildrenCategory": "0",
            "tags": [],
            "start": 0,
            "num": 50,
            "sort": 6,
            "moduleId": 3,
            "isEnabled": 1,
            seminarId: Config.seminarId,
            articleCategoryId: cateId,
        };
        return new Promise(((resolve, reject) => {
            request.getJson(Config.tenantId+'/custom/partner/' + cateId + '_2021.json', {baseURL: Config.api.gateway.JsonUrl}).then((res) => {
                if(res.result == 0){
                    // let data = extHallDataCook(res);
                    // store.commit('setExtHallListCache', data);
                    resolve(res);
                }else{
                    reject(res);
                }
            }).catch((err) => {
                //接口
                request.postJson('/api/article/category/sub/query', params).then((res) => {
                    resolve(res);
                }).catch(err=>{
                    store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            })
        }))
    },
    // 展厅详情
    getExthallDetail(cateId){
        let params={
            "isRecommend": -1,
            "instanceId": Config.instanceId,
            "title": "",
            "tenantId": Config.tenantId,
            "isStick": -1,
            "isTop": "-1",
            "isWithStat": "1",
            "hasChildrenCategory": "0",
            "tags": [],
            "start": 0,
            "num": 50,
            "sort": 6,
            "moduleId": 6,
            "isEnabled": 1,
            seminarId: Config.seminarId,
            articleCategoryId: cateId,
        };
        return new Promise(((resolve, reject) => {
            let cache = store.state.cache.extHallChildList;
            let matchIndex = -1;
            if(cache.length>0){
                cache.map((item, index)=>{
                    if(item.articleCategoryId * 1 == cateId * 1){
                        matchIndex = index;
                    }
                });
            }
            if(matchIndex != -1){
                resolve(cache[matchIndex]);
            }else{
                request.getJson(Config.tenantId+'/seminar/'+Config.seminarId+'/article/list/' + cateId + '.json', {baseURL: Config.api.gateway.JsonUrl}).then((res) => {
                    let data = exthallDetailDataCook(res);
                    store.commit('setExtHallChildListCache', data);
                    resolve(data)
                }).catch(() => {
                    //接口
                    request.postJson('/api/article/category/sub/query', params).then((res) => {
                        resolve(res);
                    })
                    .catch(err=>{
                        store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                        reject(err);
                    });
                })
            }
        }))
    },
    /**
     * 展厅详情-文字介绍和轮播图
     */
     getExthallDetail2(articleId) {
        return new Promise((resolve => {
            request.getJson(Config.tenantId + '/seminar/' + Config.seminarId + '/article/' + articleId + '.json', {baseURL: request.JsonUrl}).then((res) => {
                let data = exthallDetailDataCookStepTwo(res, articleId);
                resolve(data)
            }).catch(() => {
                //接口
                request.postJson('/article/getDetail', params).then((res) => {
                    resolve(res);
                }).catch(err=>{
                    store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            })
        }));
    },
    /**
     * 获取文件夹数据
     */
    getFileFolder(folderId, idArr=[]){
        return new Promise((resolve => {
            let cache = store.state.cache.folderMap;
            if(cache.hasOwnProperty(folderId)){
                resolve(cache[folderId]);
            }else{
                request.getJson(Config.tenantId + '/seminar/' + Config.seminarId + '/file/folder/info/' + folderId + '.json', {baseURL: request.JsonUrl}).then((res) => {
                    resolve(fileFolderDataCook(res, idArr, folderId))
                }).catch(() => {
                    //接口
                    request.postJson('/article/getDetail', params).then((res) => {
                        resolve(res);
                    }).catch(err=>{
                        store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                        reject(err);
                    });
                })
            }
        }));
    },
    // 参会指南
    getGuideContent(){
        let params={
            "isRecommend": -1,
            "instanceId": Config.instanceId,
            "title": "",
            "tenantId": Config.tenantId,
            "isStick": -1,
            "isTop": "-1",
            "isWithStat": "1",
            "hasChildrenCategory": "0",
            "tags": [],
            "start": 0,
            "num": 50,
            "sort": 6,
            seminarId: Config.seminarId,
            articleCategoryId: Config.reviewArticleCategory.guide,
        };
        return new Promise(((resolve, reject) => {
            // if(store.state.cache.extHallList){
            //     resolve(store.state.cache.extHallList);
            // }else{
                request.getJson(Config.tenantId+'/seminar/'+Config.seminarId+'/article/list/' + Config.reviewArticleCategory.guide + '.json', {baseURL: Config.api.gateway.JsonUrl}).then((res) => {
                    if(res.result == 0){
                        let data = guideDataCook(res);
                        // store.commit('setExtHallListCache', data);
                        resolve(data);
                    }else{
                        reject(res);
                    }
                }).catch(() => {
                    //接口
                    request.postJson('/api/article/category/sub/query', params).then((res) => {
                        resolve(res);
                    }).catch(err=>{
                        store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                        reject(err);
                    });
                })
            // }
        }))
    },
    // 议程地址
    getAgendaAddress(){
        let params={
            tenantId: Config.tenantId,
            seminarId: Config.seminarId,
        };
        return new Promise((resolve => {
            request.getJson(Config.tenantId + '/custom/stzx2021/partner/api_place_query.json', {baseURL: request.JsonUrl}).then((res) => {
                agendaAddressDataCook(res);
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/api/place/query', params,{baseURL: request.url}).then((res) => {
                    agendaAddressDataCook(res);
                    resolve(res);
                });
            })
        }))
    },
    // 查询议程关联文件-专题演讲
    querySpecialTopicFiles(subSeminarIds) {
        return new Promise(((resolve,reject) => {
            let cache = store.state.cache.specialFiles;
            if(Object.keys(cache).length > 0){
                resolve(cache); 
            }else{
                let params = {
                    tenantId: Config.tenantId,
                    sess: '',
                    seminarId: Config.seminarId,
                    subSeminarId: subSeminarIds,
                };
                request.postJson('/admin/topic/guest/material', params, {baseURL: request.url}).then((res)=>{
                    specialTopicFilesCook(res);
                    resolve(res);
                }).catch(err=>{
                    store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            }
        }))
    },
    /*获取注册人信息*/
     getUserOrderStatus() {
        return new Promise(((resolve,reject) => {
            let params = {
                sess: getUserSess()
            }
            if(!params.sess){
                reject('user not login');
            }else{
                //接口
                request.postJson('/partner/contacts/status', params,{baseURL: request.url}).then((res) => {
                    resolve(res);
                }).catch((err)=>{
                    reject(err);
                });
            }
        }))
    },
    /*静默报名线上会*/
    silentOrderOnline(){
        return new Promise(((resolve,reject) => {
            let params = {
                sess: getUserSess(),
                globalUserId: getGlobalUserId(),
                channel: getTc(),
                shareKey: getShareKey(),
            }
            if(!params.sess){
                reject('user not login');
            }else{
                //接口
                request.postJson('/partner/contacts/signUp', params,{baseURL: request.url}).then((res) => {
                    resolve(res);
                }).catch((err)=>{
                    // store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            }
        }))
    },
    // 获取微信分享配置
    getWxShareConfig() {
        let params={
            tenantId:  Config.tenantId,
            isWithStat: 0,//是否需要点赞、分享、浏览统计（1：是；0：否）
            isScroll: 0,//是否需要查询上一篇和下一篇文章id（1：是；0：否）
            isWithTag: 0,//是否需要标签（1：是；0：否）
            articleId: Config.wxShareConfigArticleId
        };
        return new Promise(((resolve, reject) => {
            request.getJson(Config.tenantId+'/seminar/'+Config.seminarId+'/article/' + params.articleId + '.json', {baseURL: Config.api.gateway.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/article/getDetail', params).then((res) => {
                    resolve(res);
                }).catch(err=>{
                    // store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            })
        }));
    },
    // 获取主直播配置
    getMainLive() {
        let params={
            tenantId:  Config.tenantId,
            isWithStat: 0,//是否需要点赞、分享、浏览统计（1：是；0：否）
            isScroll: 0,//是否需要查询上一篇和下一篇文章id（1：是；0：否）
            isWithTag: 0,//是否需要标签（1：是；0：否）
            articleId: Config.mainLiveArticleId
        };
        return new Promise(((resolve, reject) => {
            request.getJson(Config.tenantId+'/seminar/'+Config.seminarId+'/article/' + params.articleId + '.json', {baseURL: Config.api.gateway.JsonUrl}).then((res) => {
                resolve(res)
            }).catch(() => {
                //接口
                request.postJson('/article/getDetail', params).then((res) => {
                    resolve(res);
                }).catch(err=>{
                    // store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            })
        }));
    },
    /*预定议程*/
    orderAgenda(subSeminarId){
        return new Promise(((resolve,reject) => {
            let params = {
                sess: getUserSess(),
                globalUserId: getGlobalUserId(),
                subSeminarId: subSeminarId,
                seminarId: Config.seminarId,
            };
            if(!params.sess){
                reject('user not login');
            }else{
                //接口
                request.postJson('/partner/seminar/subseminar/reserve', params,{baseURL: request.url}).then((res) => {
                    resolve(res);
                }).catch((err)=>{
                    store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            }
        }))
    },
    /*取消议程*/
    cancelAgenda(subSeminarId){
        return new Promise(((resolve,reject) => {
            let params = {
                sess: getUserSess(),
                globalUserId: getGlobalUserId(),
                subSeminarId: subSeminarId,
            };
            if(!params.sess){
                reject('user not login');
            }else{
                //接口
                request.postJson('/partner/seminar/subseminar/cancelreserve', params,{baseURL: request.url}).then((res) => {
                    resolve(res);
                }).catch((err)=>{
                    store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            }
        }))
    },
    /*预约议程列表*/
    myOrderAgenda(){
        return new Promise(((resolve,reject) => {
            let params = {
                sess: getUserSess(),
            };
            if(!params.sess){
                reject('user not login');
            }else{
                //接口
                request.postJson('/partner/seminar/subseminar/myseminar', params,{baseURL: request.url}).then((res) => {
                    resolve(res);
                }).catch((err)=>{
                    store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            }
        }))
    },
    /*收藏展厅*/
    collectExthall(id, name){
        return new Promise(((resolve,reject) => {
            let params = {
                sess: getUserSess(),
                objectId: id,
                objectName: name,
                unique: store.state.myData.phone,
                objectType: 'booth',
                seminarId: Config.seminarId,
            };
            if(!params.sess){
                reject('user not login');
            }else{
                //接口
                request.postJson('/api/collection/save', params,{baseURL: request.url}).then((res) => {
                    resolve(res);
                }).catch((err)=>{
                    store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            }
        }))
    },
    /*取消收藏展厅*/
    cancelCollectExthall(id, name){
        return new Promise(((resolve,reject) => {
            let params = {
                sess: getUserSess(),
                objectId: id,
                // objectName: name,
                seminarId: Config.seminarId,
                objectType: 'booth',
            };
            if(!params.sess){
                reject('user not login');
            }else{
                //接口
                request.postJson('/api/collection/cancel', params,{baseURL: request.url}).then((res) => {
                    resolve(res);
                }).catch((err)=>{
                    store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            }
        }))
    },
    /*收藏展厅列表*/
    myCollectExthall(){
        return new Promise(((resolve,reject) => {
            let params = {
                sess: getUserSess(),
                seminarId: Config.seminarId,
                // unique: store.state.myData.phone,
                unique: '',
                objectType: 'booth',
            };
            if(!params.sess){
                reject('user not login');
            }else{
                //接口
                request.postJson('/api/collection/query', params,{baseURL: request.url}).then((res) => {
                    resolve(res);
                }).catch((err)=>{
                    store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            }
        }))
    },
    /*直播间状态*/
    liveHallStatus(ids){
        return new Promise(((resolve,reject) => {
            let params = {
                ids: ids,
            };
            //接口
            request.postJson('/partner/vhall/status', params,{baseURL: request.url}).then((res) => {
                resolve(res);
            }).catch((err)=>{
                store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                reject(err);
            });
        }))
    },
    /*下载资料记录列表*/
    myDownloadLogList(page=0, limit=10){
        return new Promise(((resolve,reject) => {
            let params = {
                sess: getUserSess(),
                globalUserId: getGlobalUserId(),
                seminarId: Config.seminarId,
                start: limit * page,
                num: limit
            };
            if(!params.sess){
                reject('user not login');
            }else{
                //接口
                request.postJson('/partner/file/download/query', params,{baseURL: request.url}).then((res) => {
                    resolve(res);
                }).catch((err)=>{
                    store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            }
        }))
    },
    /*获取参会人信息*/
    myContacts(){
        return new Promise(((resolve,reject) => {
            let params = {
                sess: getUserSess(),
                tenantId: Config.tenantId,
                seminarId: Config.seminarId,
            };
            if(!params.sess){
                reject('user not login');
            }else{
                //接口
                request.postJson('/partner/contacts/get', params,{baseURL: request.url}).then((res) => {
                    resolve(res);
                }).catch((err)=>{
                    store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            }
        }))
    },
    /*获取参会人签到信息*/
    mySignupInfo(seminarId){
        return new Promise(((resolve,reject) => {
            let params = {
                sess: getUserSess(),
                globalUserId: getGlobalUserId(),
                tenantId: Config.tenantId,
                seminarId: seminarId,
            };
            if(!params.sess){
                reject('user not login');
            }else{
                //接口
                request.postJson('/api/seminar/contacts/get', params).then((res) => {
                    userDataCook(res);
                    resolve(res);
                }).catch((err)=>{
                    store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                    reject(err);
                });
            }
        }))
    },
    /*获取服务器时间*/
    getTime(){
        return new Promise(((resolve,reject) => {
                //接口
                request.postJson('/api/project/server/GetTime', {}, {baseURL: request.url})
                .then(res=>{
                    resolve(res);
                }).catch(err=>{
                    reject(err);
                });
        }));
    },
}
